import React, {useContext, useEffect, useState} from 'react'
import localization from "../../../../../assets/localization/localization";
import Layout from "../../../../../components/sales/layout/layout";
import DivLayout from "../../../../../components/sales/divLayout/divLayout";
import {Button} from "react-bootstrap";
import {toast} from "react-toastify";
import ModalPop from "../../../../../components/sales/modal/modal";
import ConstantInput from "../../../../../components/sales/Input/constantInput/constantInput";
import CustomModal from "../../../../valetServices/modal";
import {BaseUrl} from "../../../../../contexts/baseUrl/baseUrl";
import './view.css'

const ApprovalValetInvoiceLineItems = ({
                                           match,
                                           getValetItemLineInvoiceId,
                                           lineItemsByInvoiceId = [],
                                           lineItemsApprovalRejection,
                                           lineItemsApprovalRejectionResponse=[],
                                           history
                                       }) => {

    const { baseUrl } = useContext(BaseUrl);
    const [listData, setListData] = useState([{}]);
    const [isLoading, setIsLoading] = useState(false);
    const [sum, setSum] = useState(0);
    const [isModal, setIsModal] = useState(false);
    const [approvalStatus, setApprovalStatus] = useState(0);
    const [remarks, setRemarks] = useState("");
    const [showModalContent, setShowModalContent] = useState(true)
    const [count, setCount] = useState(0)
    const [role, setRole] = useState('')

    useEffect(() => {
        (async () => {
            setIsLoading(true)
            setRole(localStorage.getItem("fusion-role"))
            getValetItemLineInvoiceId(match?.params?.invoice_id)
            setIsLoading(false)
        })()
    }, []);


    useEffect(() => {
        if (lineItemsByInvoiceId && lineItemsByInvoiceId?.length > 0) {
            setListData(lineItemsByInvoiceId)
            setTimeout(() => {
                setIsLoading(true)
                setIsLoading(false)
            }, 500)
        }
    }, [lineItemsByInvoiceId])

    const setStatus = (status) => {
        setIsModal(true)
        setApprovalStatus(status)
    }

    useEffect(() => {
        let list = [...listData]
        let s = 0;
        list.map(v => {
            s += v?.unit_price * v?.men_days * v?.quantity
        })
        setSum(s)
    }, [listData])

    const handleSubmit = async () => {

        if(remarks === ""){
            toast.error("Remark is required");
            return false
        }
        const submitData = {remark: remarks, installment_invoice_id: match?.params?.invoice_id, action:approvalStatus};
        setShowModalContent(false)
        setIsLoading(true)
        await lineItemsApprovalRejection(submitData)
        setIsLoading(false)
        setCount(count + 1)
        setIsModal(false)
        setShowModalContent(true)
    }

    return (
        <>
            <Layout
                title={localization.lineItem}
                isLoading={isLoading}
                isGoback={true}
            >
                {lineItemsByInvoiceId && lineItemsByInvoiceId.length > 0 &&
                    <>
                        <div className="panel-card card-details" width="100%">
                            {lineItemsApprovalRejectionResponse !== null && lineItemsApprovalRejectionResponse?.response?.status !== 200 &&
                                <CustomModal msg={lineItemsApprovalRejectionResponse?.response?.message} click={count} history={history}/>}
                            {lineItemsApprovalRejectionResponse !== null && lineItemsApprovalRejectionResponse?.response?.status === 200 &&
                                <CustomModal msg={lineItemsApprovalRejectionResponse?.response?.message} isPageLoad={true} history={history}
                                             url={`${baseUrl}/valet-approval-invoice-list`} click={count}/>}
                            <div className="panel-heading">{localization.lineItem}</div>
                            <div className="panel-body">
                                <div className="details-listing detail_alignment">
                                    <DivLayout
                                        heading={"Invoice Id"}
                                        data={
                                            match?.params?.invoice_id
                                        }
                                    />
                                    <DivLayout
                                        heading={"Status"}
                                        data={
                                            listData[0]?.status
                                        }
                                    />
                                    <DivLayout
                                        heading={"Invoice Number"}
                                        data={
                                            listData[0]?.invoice_no
                                        }
                                    />
                                    <table className="table table-responsive table-info valet-table-item-lint-heading">
                                        <thead>
                                        <th className="valet-item-lint-heading">Item</th>
                                        <th className="valet-item-lint-heading">Type</th>
                                        <th className="valet-item-lint-heading">Quantity</th>
                                        <th className="valet-item-lint-heading">Unit Price</th>
                                        <th className="valet-item-lint-heading">Men Days</th>
                                        <th className="valet-item-lint-heading">Total Men Days</th>
                                        <th className="valet-item-lint-heading">Total Price</th>
                                        </thead>
                                        <tbody>
                                        {listData !== undefined && listData.length > 0 && listData.map((val, i) => {
                                            return (
                                                <>
                                                    {val?.type === 'On Demand' &&
                                                        <tr>
                                                            <td>{val?.services?.service_name}</td>
                                                            <td>{"On Demand"}</td>
                                                            <td>{val?.quantity}</td>
                                                            <td>{val?.unit_price}</td>
                                                            <td>{val?.men_days}</td>
                                                            <td>{val?.quantity * val?.men_days}</td>
                                                            <td>{val?.quantity * val?.men_days * val.unit_price}</td>
                                                        </tr>
                                                    }
                                                    {val?.type === 'Variable' &&
                                                        <tr>
                                                            <td>{val?.services?.service_name}</td>
                                                            <td>{"Variable"}</td>
                                                            <td>{val?.quantity}</td>
                                                            <td>{val?.unit_price}</td>
                                                            <td>{val?.men_days}</td>
                                                            <td>{val?.quantity * val?.men_days}</td>
                                                            <td>{val?.quantity * val?.men_days * val.unit_price}</td>
                                                        </tr>
                                                    }

                                                    {val?.type === 'Fixed' &&
                                                        <tr>
                                                            <td>{val?.services?.service_name}</td>
                                                            <td>{"Fixed"}</td>
                                                            <td>{val?.quantity}</td>
                                                            <td>{val?.unit_price}</td>
                                                            <td>{val?.men_days}</td>
                                                            <td>{val?.quantity * val?.men_days}</td>
                                                            <td>{val?.quantity * val?.men_days * val.unit_price}</td>
                                                        </tr>
                                                    }

                                                </>
                                            )
                                        })
                                        }
                                        <tr>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td>Sum</td>
                                            <td>{sum}</td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                                {parseInt(role) === 16 &&
                                    <>
                                        <div className="container-fluid">
                                            <div className="valet-approval-text-center">
                                                <Button type="button" onClick={() => setStatus(2)} style={{'marginRight':'14%'}}>Approve</Button>
                                                <Button type="button"  onClick={() => setStatus(3)}>Reject</Button>
                                            </div>
                                        </div>

                                        {showModalContent &&
                                            <ModalPop
                                                title={localization.remark}
                                                show={isModal}
                                                handleModalHide={() => setIsModal(false)}
                                                isLoading={isLoading}
                                            >
                                                <ConstantInput
                                                    label={localization.remark}
                                                    value={""}
                                                    type="text"
                                                    handleChange={(val) =>
                                                        setRemarks(val)
                                                    }
                                                />
                                                <Button type="btn btn-danger" onClick={handleSubmit}>Submit</Button>
                                            </ModalPop>
                                        }
                                    </>
                                }

                            </div>
                        </div>
                    </>
                }

            </Layout>
        </>
    )
}

export default ApprovalValetInvoiceLineItems